<form *ngIf="form" [formGroup]="form" >
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">{{fields.title}}</h1>
      </div>

      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/selfscanservicedetail/{{form.get('self_scanning_service_id').value}}" label="{{ 'common.back' | translate }}"></button>
      </div>
      <div class="ui-g-12">
        <hr>
        <h3 class="title">{{ fields.header }}</h3>
      </div>
    </div>

    <div class="card">

      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.customer_id }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="customer_description"/>
          <input type="string" hidden disabled pInputText class="fieldInput" formControlName="self_scanning_service_id"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.card_id }}</span>
          <input type="number" disabled pInputText class="fieldInput" formControlName="card_id"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.division_id }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="division_id"/>
        </div>

      </div>


      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.store_id }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="store_id"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.trxNum }}</span>
          <input type="number" disabled pInputText class="fieldInput" formControlName="trxNumCassa"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.termCode }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="termCodeCassa"/>
        </div>

      </div>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.reason_description }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="reason_description" />
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.startTime }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="startTimeCassa" />
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.endTime }}</span>
          <input type="string" disabled pInputText class="fieldInput" formControlName="endTimeCassa" />
        </div>

      </div>

      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.itemsNumberCassa }}</span>
          <input type="number" disabled pInputText class="fieldInput" formControlName="itemsNumberCassa"/>
        </div>

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.itemsNumberApp }}</span>
          <input type="number" disabled pInputText class="fieldInput" formControlName="itemsNumberApp"/>
        </div>

      </div>

      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.totalAmountCassa }} €</span>
          <input type="number" disabled pInputText class="fieldInput" formControlName="totalAmountCassa"/>
        </div>

        <div class="ui-g-12 ui-md-3">
          <span class="label">{{ fields.totalAmountApp }} €</span>
          <input type="number" disabled pInputText class="fieldInput" formControlName="totalAmountApp"/>
        </div>

      </div>

    </div>

  </div>

  <div class="ui-g-12">
    <div class="ui-g-3"></div>
    <div class="ui-g-3">
      <button
        pButton
        class="k-generic-btn"
        icon="fa fa-search-plus"
        style="width: 100% !important;"
        [label]="'common.detail' | translate"
        (click)="openDetail()" >
      </button>
    </div>
    <div class="ui-g-3"></div>
    <div class="ui-g-3"></div>
  </div>

  <div *ngIf="showDetail" class="Loyalty ui-g-12 ui-md-12 ui-lg-12">

    <div class="ui-g">

      <div class="ui-g-12">
        <hr>
        <h3 class="title">{{ fields.itemsTitle }}</h3>
      </div>
    </div>

    <div formArrayName="details" >
      <div class="repeater-panel" *ngFor="let detail of details.controls; let i=index" [formGroupName]="i">
        <p-panel>

          <p-header>
            <span class="ui-panel-title">#{{ i + 1 }}</span>
             </p-header>

          <div class="clearfix">
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ fields.itemId }}</span>
              <input hidden type="string" pInputText class="fieldInput" formControlName="check_price"/>
              <input hidden type="string" pInputText class="fieldInput" formControlName="check_quantity"/>
              <input disabled type="string" pInputText class="fieldInput" formControlName="itemId"/>
            </div>
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ fields.barcode }}</span>
              <input type="number" disabled pInputText class="fieldInput" formControlName="barcode"/>
            </div>
            <div class="ui-g-12 ui-md-4">
              <span class="label">{{ fields.action }}</span>
              <input disabled type="string" pInputText class="fieldInput" formControlName="action"/>
            </div>
          </div>
          <div class="clearfix">
            <div class="ui-g-12 ui-md-3">
              <span class="label">{{ fields.quantity_cassa }}</span>
              <input disabled type="string" pInputText class="fieldInput" formControlName="quantity_cassa"/>
            </div>
            <div class="ui-g-12 ui-md-3">
              <span class="label">{{ fields.quantity_app }}</span>
              <input *ngIf="detail.get('check_quantity').value === 1" style="background: lightcoral;" disabled type="string" pInputText class="fieldInput" formControlName="quantity_app"/>
              <input *ngIf="detail.get('check_quantity').value === 0" disabled type="string" pInputText class="fieldInput" formControlName="quantity_app"/>

            </div>
            <div class="ui-g-12 ui-md-3">
              <span class="label">{{ fields.regularPrice_cassa }} €</span>
              <input disabled type="string" pInputText class="fieldInput" formControlName="regularPrice_cassa"/>
            </div>
            <div class="ui-g-12 ui-md-3">
              <span class="label">{{ fields.regularPrice_app }} €</span>

              <input *ngIf="detail.get('check_price').value === 1 " style="background: lightcoral;" disabled type="string" pInputText class="fieldInput" formControlName="regularPrice_app"/>
              <input *ngIf="detail.get('check_price').value === 0 "  disabled type="string" pInputText class="fieldInput" formControlName="regularPrice_app"/>

            </div>
          </div>

        </p-panel>
      </div>
    </div>



  </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service-trx/loyalty-self-scan-service-trx.component.html